<template>
    <b-row class="h-100 align-items-center">
        <b-col class="mx-auto">
            <b-col sm="6" offset-sm="3" class="text-center">
                <b-spinner variant="primary" small></b-spinner> <span class="h6">Carregando dados...</span>
            </b-col>
        </b-col>
    </b-row>
</template>
<script>
export default {
};
</script>
